import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIHoverActionController } from './UIHoverActionController.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { getCardsForPiece } from '@colonist/game-card-types';
import { MechanicValidatorCity } from '@colonist/game-mechanic-validators';
export class UICityHoverActionController extends UIHoverActionController {
    getBankActionAmount(index) {
        const cityPlayerState = this.cityValidator.getCityPlayerState(this.uiGameManager.gameController.myColor);
        return cityPlayerState.bankCityAmount;
    }
    updateState() {
        const player = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.myColor);
        const canPlaceCity = this.cityValidator.canPlayerPlaceCity(player.color);
        this.updateHoverLocations(canPlaceCity.validHoverLocations, canPlaceCity.canTakeAction);
        this.uiGameManager.mapController.hoverController.onHoverStateChange();
    }
    getTexture(index) {
        return UIGameSpriteHandler.getCityForPlayer(this.uiGameManager.gameController.myColor);
    }
    constructor(uiGameManager, cityState){
        super(uiGameManager);
        this.isCornerAction = true;
        this.resources = getCardsForPiece(PieceTypes.City);
        this.action = (index)=>this.uiGameManager.socketGameSend.confirmBuildCitySkippingSelection(index);
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this);
        this.cityValidator = new MechanicValidatorCity(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, cityState);
    }
}
